import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, Button, Text, Image, Flex } from "@chakra-ui/react";

interface Props {
  isOpen: boolean;
  full_name: string;
  user_name: string;
  email: string
  nationality: string
  date_of_birth: string
  gender: string
  user_profile_image: string
  city: string
  country: string
  description: string
  instagram_link: string
  phone_number: string
  is_public: boolean
  created_at: string
  updated_at: string
  is_km_disabled: boolean
  latitude: number
  longitude: number
  country_code: string
  is_email_verified: boolean
  onClose: () => void;
}

function UserModal({ isOpen, full_name, user_name, email, nationality, date_of_birth, gender, user_profile_image, city, country, description, instagram_link, phone_number, is_public, created_at, updated_at, is_km_disabled, latitude, longitude, country_code, is_email_verified, onClose }: Props) {
  return (
    <Modal blockScrollOnMount={true} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        minH="fit-content"
        zIndex="1"
        minWidth={{
          lg: "60vw",
          md: "80vw",
          base: "98vw",
        }}
      >
        <ModalHeader textAlign="center" fontSize="2xl" fontWeight="bold">
          User Details
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex direction="column" alignItems="center">
            {user_profile_image && (
              <Image src={user_profile_image} alt={full_name} borderRadius="full" boxSize="100px" />
            )}
            <Text mt={4} fontWeight="bold" fontSize="xl">
              {full_name}
            </Text>
            <Text color="gray.500">{email}</Text>
            <Text mt={2}>{`Username: ${user_name}`}</Text>
            <Text mt={2}>{`Nationality: ${nationality}`}</Text>
            <Text mt={2}>{`Date of Birth: ${new Date(date_of_birth).toLocaleDateString()}`}</Text>
            <Text mt={2}>{`Gender: ${gender}`}</Text>
            <Text mt={2}>{`Country Code: ${country_code}`}</Text>
            <Text mt={2}>{`Verified Email: ${is_email_verified ? 'Yes' : 'No'}`}</Text>
            <Text mt={2}>{`City: ${city || 'N/A'}`}</Text>
            <Text mt={2}>{`Country: ${country || 'N/A'}`}</Text>
            <Text mt={2}>{`Description: ${description || 'N/A'}`}</Text>
            <Text mt={2}>{`Instagram Link: ${instagram_link || 'N/A'}`}</Text>
            <Text mt={2}>{`Phone Number: ${phone_number || 'N/A'}`}</Text>
            <Text mt={2}>{`Is Public: ${is_public ? 'Yes' : 'No'}`}</Text>
            <Text mt={2}>{`Created At: ${new Date(created_at).toLocaleString()}`}</Text>
            <Text mt={2}>{`Updated At: ${new Date(updated_at).toLocaleString()}`}</Text>
            <Text mt={2}>{`Is KM Disabled: ${is_km_disabled ? 'Yes' : 'No'}`}</Text>
            <Text mt={2}>{`Latitude: ${latitude || 'N/A'}`}</Text>
            <Text mt={2}>{`Longitude: ${longitude || 'N/A'}`}</Text>
          </Flex>
        </ModalBody>

        <ModalFooter justifyContent="center">
          <Button colorScheme="blue" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default UserModal;
